export enum BatsSportAttributePositions {
    PITCHER = 'P',
    CATCHER = 'C',
    FIRST_BASE = '1B',
    SECOND_BASE = '2B',
    THIRD_BASE = '3B',
    SHORTSTOP = 'SS',
    LEFT_FIELD = 'LF',
    CENTER_FIELD = 'CF',
    RIGHT_FIELD = 'RF',
    SHORT_FIELD = 'SF',
    OUTFIELD = 'OF',
    INFIELD = 'IF',
    UTILITY = 'UT',
}

/** The positions a player is scored at, in scorebook order. Excludes the grouping values (OF/IF/UT). */
export const FIELDING_POSITIONS = [
    BatsSportAttributePositions.PITCHER,
    BatsSportAttributePositions.CATCHER,
    BatsSportAttributePositions.FIRST_BASE,
    BatsSportAttributePositions.SECOND_BASE,
    BatsSportAttributePositions.THIRD_BASE,
    BatsSportAttributePositions.SHORTSTOP,
    BatsSportAttributePositions.LEFT_FIELD,
    BatsSportAttributePositions.CENTER_FIELD,
    BatsSportAttributePositions.RIGHT_FIELD,
    BatsSportAttributePositions.SHORT_FIELD,
] as const;

export type FieldingPosition = `${(typeof FIELDING_POSITIONS)[number]}`;
